import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { useContentOverflow } from '../../../../hooks'
import { stopPropagation } from '../../../../utils/events'
import Button from '../../../Button'
import { FloatingTooltip } from '../../../Floating'
import { Link } from '../../../Link'
import Text from '../../../Text'

import * as styles from './ProfileInfoWidgetItemValue.module.css'

function ProfileInfoWidgetItemValue({ qaName, to, value, onClick }) {
  const { overflow, setContentOverflowRef } = useContentOverflow({
    dep: [value],
  })

  function handleClick(event) {
    stopPropagation(event)

    onClick(value)
  }

  return onClick ? (
    <Button.Text
      className={styles.button}
      qaName={qaName}
      tooltip={overflow ? value : null}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
      onClick={handleClick}
    >
      <Text className={styles.text} ref={setContentOverflowRef}>
        {value}
      </Text>
    </Button.Text>
  ) : (
    <FloatingTooltip content={value} disabled={!overflow}>
      {to ? (
        <Link
          className={styles.link}
          ref={setContentOverflowRef}
          to={to}
          onClick={stopPropagation}
        >
          {value}
        </Link>
      ) : (
        <Text className={styles.text} ref={setContentOverflowRef}>
          {value}
        </Text>
      )}
    </FloatingTooltip>
  )
}

export default ProfileInfoWidgetItemValue
